// extracted by mini-css-extract-plugin
export default {"typeCards__item":"CatalogTypeCareItem_typeCards__item__ZnzGH","typeCards__item_selected":"CatalogTypeCareItem_typeCards__item_selected__C7S10"};